module.exports = __webpack_public_path__ + "assets/atlassian-jira.a397460c.svg";